export const positiveNegativeMap = [
    { value: 'DNK', description: '- Select -' },
    { value: 'POS', description: 'Positive' },
    { value: 'NEG', description: 'Negative' },
];

export const tbStatusMap = [
    { value: '', description: '- Select -' },
    { value: 'Active', description: 'Active' },
    { value: 'Latent', description: 'Latent' },
    { value: 'Negative', description: 'Negative' },
    { value: 'Untested', description: 'Untested' },
]